import { ComposerForm } from "@/react/components/CommentsCompass/Composer/ComposerForm";
import { useCommentsScroll } from "@/react/components/CommentsCompass/Provider/ScrollContext";
import type { Comment } from "@/react/types/Comment";

import { useReplyComposerFocus } from "./useReplyComposerFocus";

interface ReplyComposerProps {
  parentComment: Comment;
}

export const ReplyComposer = ({ parentComment }: ReplyComposerProps) => {
  const { requestScrollToComment } = useCommentsScroll();
  const { isFocusPending, mentionCommunityMember, onFocusHandled } =
    useReplyComposerFocus(parentComment.id);

  return (
    <ComposerForm
      className="py-5"
      parentCommentId={parentComment.id}
      replyToCommunityMember={parentComment.community_member}
      mentionCommunityMember={mentionCommunityMember}
      isFocusPending={isFocusPending}
      onFocusHandled={onFocusHandled}
      onCreate={comment => requestScrollToComment(comment.id)}
    />
  );
};
